export const timeOptions = [
  {
    value: '5 min',
    label: '5 min',
  },
  {
    value: '10 min',
    label: '10 min',
  },
  {
    value: '15 min',
    label: '15 min',
  },
  {
    value: '20 min',
    label: '20 min',
  },
  {
    value: '25 min',
    label: '25 min',
  },
  {
    value: '30 min',
    label: '30 min',
  },
  {
    value: '35 min',
    label: '35 min',
  },
  {
    value: '40 min',
    label: '40 min',
  },
  {
    value: '45 min',
    label: '45 min',
  },
  {
    value: '50 min',
    label: '50 min',
  },
  {
    value: '55 min',
    label: '55 min',
  },
  {
    value: '60 min',
    label: '60 min',
  },
  {
    value: '65 min',
    label: '65 min',
  },
  {
    value: '70 min',
    label: '70 min',
  },
  {
    value: '75 min',
    label: '75 min',
  },
  {
    value: '80 min',
    label: '80 min',
  },
  {
    value: '85 min',
    label: '85 min',
  },
  {
    value: '90 min',
    label: '90 min',
  },
  {
    value: '95 min',
    label: '95 min',
  },
  {
    value: '100 min',
    label: '100 min',
  },
  {
    value: '105 min',
    label: '105 min',
  },
  {
    value: '110 min',
    label: '110 min',
  },
  {
    value: '115 min',
    label: '115 min',
  },
  {
    value: '120 min',
    label: '120 min',
  },
];
